export default {
  'labels.email': 'Email',
  'labels.select': 'Select',
  'labels.name': 'Name',
  'labels.password': 'Password',
  'labels.username': 'Username',
  'labels.gaCode': 'GA Code',
  'labels.emailOtp': 'Email OTP',
  'labels.confirmPwd': 'Confirm password'
};
